import { QueryClientScope } from "../types";
import { getUserSetting } from "./getUserSetting";
import { UserSettingsKey, GetUserSettingsResponse } from "./types";
import { useQuery } from "@tanstack/react-query";

export const useGetUserSetting = (key: UserSettingsKey) => {
  return useQuery<GetUserSettingsResponse, Error>({
    queryKey: [QueryClientScope.UserSetting, key],
    queryFn: () => getUserSetting(key),
    retry: false,
    enabled: key.length > 0,
    staleTime: 5 * 60 * 1000,
  });
};
